import React from 'react';
import './team.css'; 
import bgteam from '../images/bgteam.webp';
import bgteam2 from '../images/bgteam2.webp';

function TeamBg() {
  return (
    <>
      <section className='teamBg' >
        <img src={`${bgteam}`} alt='team1'></img>
        <img src={`${bgteam2}`} alt='team2'></img>
      </section>
    </>
  );
}
export default TeamBg;